import "../css/_app.css";

import { initLenis } from "./scroll/lenis";
import { initObservers } from "./scroll/observer";
import { initLoader } from "./core/loader";
import { initFontLoader } from "./core/fontloader";
import { initNavigation } from "@/ui/navigation";

const ready = (fn) => {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn, { once: true });
  else fn();
};

ready(() => {
  initLoader();        // sets is-loading/is-ready classes etc ASAP
  initFontLoader();    // if it toggles fonts-loaded
  initLenis();
  initObservers();
  initNavigation();    // if it “replaces DOM”, run after base state is set
});
